import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  isSupported,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAjjqzEDM6_kNhrY8U3R85Id1UulBv3L_c",
  authDomain: "care-dpc.firebaseapp.com",
  projectId: "care-dpc",
  storageBucket: "care-dpc.firebasestorage.app",
  messagingSenderId: "669978133645",
  appId: "1:669978133645:web:ec8fb9cbe13d40b19ccec4",
  measurementId: "G-RSK3JJDX0B",
};

const app = initializeApp(firebaseConfig);

let messaging = null;

export const getFirebaseMessaging = async () => {
  try {
    const supported = await isSupported();

    if (!supported) {
      console.log("❌ Firebase Messaging is not supported");
      return null;
    }

    if (!messaging) {
      messaging = getMessaging(app);
    }

    return messaging;
  } catch (error) {
    console.error("❌ Firebase Messaging initialization error:", error);
    return null;
  }
};

export const requestForToken = async () => {
  try {
    if (!("Notification" in window)) {
      console.log("❌ Browser does not support notifications");
      return null;
    }

    if (!("serviceWorker" in navigator)) {
      console.log("❌ Service workers are not supported");
      return null;
    }

    console.log(
      "🔔 Current notification permission:",
      Notification.permission
    );

    let permission = Notification.permission;

    // Ask permission only when browser has not decided yet
    if (permission === "default") {
      permission = await Notification.requestPermission();

      console.log(
        "🔔 Permission result:",
        permission
      );
    }

    // User/browser has explicitly denied notifications
    if (permission !== "granted") {
      console.log(
        "❌ Notification permission is not granted:",
        permission
      );

      return null;
    }

    const messagingInstance =
      await getFirebaseMessaging();

    if (!messagingInstance) {
      return null;
    }

    /**
     * Register the Firebase messaging service worker.
     *
     * The file must exist at:
     *
     * public/firebase-messaging-sw.js
     */
    const registration =
      await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js"
      );

    console.log(
      "✅ Firebase service worker registered:",
      registration
    );

    await navigator.serviceWorker.ready;

    const token = await getToken(
      messagingInstance,
      {
        vapidKey:
          "BMGxafCE22xwAuaJWhn5bNb7tSi891IXvUtyc3Vas32sSi8suYd78zTXvlEmpZGBrcth2yeOTSNs0nPE8jQu1lc",
        serviceWorkerRegistration:
          registration,
      }
    );

    if (!token) {
      console.log("❌ FCM token was not generated");
      return null;
    }

    console.log(
      "✅ FCM Token:",
      token
    );

    return token;

  } catch (error) {
    console.error(
      "❌ Error getting FCM token:",
      error
    );

    return null;
  }
};